import { z } from "zod";

export const PoolLeaderboardEntrySchema = z.object({
  rank: z.number().int().positive(),
  poolId: z.string(),
  participantId: z.string(),
  totalPoints: z.number().int(),
  userId: z.string(),
  userName: z.string(),
  userAvatar: z.string().nullable(),
});

export const PoolLeaderboardQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  pageSize: z.coerce.number().int().positive().max(100).default(20),
});

export type PoolLeaderboardEntryDTO = z.infer<typeof PoolLeaderboardEntrySchema>;
export type PoolLeaderboardQueryDTO = z.infer<typeof PoolLeaderboardQuerySchema>;
